/**
 * Returns the correct base path at runtime.
 *
 * When the app is served from a dedicated domain (e.g. benefit.3o3.co.kr)
 * whose CloudFront origin_path already maps to the S3 subpath,
 * the browser URL is "/" — so the base is "/".
 *
 * When served from playground.3o3.co.kr/gov-benefit/,
 * the pathname starts with "/gov-benefit", so we use that as the base.
 * The subpath root without a trailing slash ("/gov-benefit") is served as-is,
 * so it counts as the subpath too.
 */
export function getRuntimeBase(): string {
  const subpath = '/gov-benefit/';
  const { pathname } = window.location;

  if (pathname === subpath.slice(0, -1) || pathname.startsWith(subpath)) {
    return subpath;
  }

  return '/';
}
